import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import {
	createPageLoadMetric,
	createPageSegmentLoadMetric,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	UNIFIED_SEARCH_LOAD_KEY,
	ADVANCED_SEARCH_LOAD_KEY,
	ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY,
	ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY,
	ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const ADVANCED_SEARCH_PAGE_LOAD = createPageLoadMetric({
	key: ADVANCED_SEARCH_LOAD_KEY,
});

export const ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY,
	});

export const ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY,
	});

export const ADVANCED_SEARCH_FILTER_SECTION_PAGE_SEGMENT_LOAD: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY,
	});

export const UNIFIED_SEARCH_PAGE_LOAD = createPageLoadMetric({
	key: UNIFIED_SEARCH_LOAD_KEY,
});
